import ApiService from './ApiService.js'
import ApiHelper from './ApiHelper.js'

export default {
    deleteEntity(href) {
        let header = ApiHelper.getHeader();
        return ApiService().delete(href,
            { 
                headers: header
            });
    },
    update(href, entity) {
        let header = ApiHelper.getHeader();
        return ApiService().put(href, entity,
            { 
                headers: header
            });
    },
    insert(href, entity) {
        let header = ApiHelper.getHeader();
        return ApiService().post(href, entity,
            { 
                headers: header
            });
    },
    getCollection(href) {
        let header = ApiHelper.getHeader();
        return ApiService().get(href,
        { 
            headers: header
        });
    },
}